'use es6';

import * as http from '../../../request/http';
export const search = (searchUrl, payload) => http.post(searchUrl, {
  data: payload,
  query: {
    allPropertiesFetchMode: 'latest_version'
  }
});